module.exports = {
      id: "politics-all-usage",
      viewBox: "0 0 93.75 88.955",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#politics-all",
      toString: function () {
        return this.url;
      }
    }